import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/brand/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/brand/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/brand/FETCH_FAILURE'
const CREATE_REQUEST = 'realhub/brand/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/brand/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/brand/CREATE_FAILURE'
const UPDATE_REQUEST = 'realhub/brand/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/brand/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/brand/UPDATE_FAILURE'

const SELECT_BRAND = 'realhub/provider/SELECT_BRAND'


// Initial State
const initialState = {
  creating: false,
  errors: [],
  loaded: false,
  loadedBrandIds: [],
  loading: false,
  result: [],
  selected: {},
  selectedId: null,
  updating: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    result: payload.result,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(payload = {}){
  return {
    type: CREATE_SUCCESS,
    result: payload.result,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function selectBrand(brandId){
  return (dispatch, getState) => {
    const state = getState()
    const { brands } = state.entities

    const selectedBrand = brands[brandId] || {}

    dispatch({
      type: SELECT_BRAND,
      selectedId: brandId,
      selected: selectedBrand,
    })
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function hydrateBrand(brand){
  const normalizedJson = normalize(brand, Schemas.BRAND)

  return (dispatch) => {
    dispatch(updateEntities(normalizedJson))
  }
}

export function loadBrands(options){
  return (dispatch) => {
    // Set Loading
    dispatch(fetchRequest())

    const promise = api('/admin/brands.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.BRAND_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(normalizedJson.result))

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function loadBrand(brand, options){
  return (dispatch, getState) => {
    const { brands } = getState()

    // Set Loading
    const loadedBrandIds = [...brands.loadedBrandIds]
    if (!loadedBrandIds.includes(brand.id)){
      loadedBrandIds.push(brand.id)
    }

    dispatch(fetchRequest({ loadedBrandIds }))

    const promise = api(`/admin/brands/${brand.id}.json`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Add to result array
        const result = brands.result ? brands.result.slice() : []
        if (!result.includes(json.id)){
          result.push(json.id)
        }

        const normalizedJson = normalize(json, Schemas.BRAND)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess({ result }))

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function createBrand(brand, options){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      brand,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api('/admin/brands.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.BRAND)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess(normalizedJson))

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function updateBrand(brand, options){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      brand,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/brands/${brand.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.BRAND)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        errors: [],
        loaded: true,
        loading: false,
        result: action.result,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        errors: action.errors,
        loaded: false,
        loading: false,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
        result: action.result,
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        errors: [],
        result: action.result,
        updating: false,
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    case SELECT_BRAND:
      return {
        ...state,
        selected: action.selected,
        selectedId: action.selectedId,
      }
    default:
      return state
  }
}
